import React, { useEffect, useState } from 'react'
import SliderContent from './SliderContent';
import Arrow from './Arrow';
import "./slider.scss";
import Dots from './Dots';
import { FormElems } from 'components';

const Slider = (props) => {
    const {sliderImages, handleDeleteFile, activeIndex, setActiveIndex} = props;
    const len = sliderImages.length - 1;


    // useEffect(() => {
    //     const interval = setInterval(() => {
    //         setActiveIndex(activeIndex === len ? 0: activeIndex+1)
    //     }, 5000);
    //     return () => {clearInterval(interval)}
    // }, [activeIndex]);
    return (
        <div className='slider-container'>
            <SliderContent 
                activeIndex={activeIndex} 
                sliderImage={sliderImages}
            />
            {len > 0 && (
                <Arrow
                    prevSlide={() => 
                        setActiveIndex(activeIndex < 1 ? len  : activeIndex - 1)
                    }
                    nextSlide={() => 
                        setActiveIndex(activeIndex === len ? 0 : activeIndex + 1)
                    }
                />
            )}
            <Dots
                activeIndex={activeIndex}
                sliderImage={sliderImages}
                onClick={(activeIndex) => setActiveIndex(activeIndex)}
            />
            {
                !!handleDeleteFile && (
                    <div className="slider-button">
                        <FormElems.Button 
                            type="button"
                            buttonType="primary"
                            id="remove-image"
                            text="Delete"
                            handleClick={() => handleDeleteFile(activeIndex)}
                        />
                    </div>
                )
            }
        </div>
    )
}

export default Slider
